import {
  AUTO_SCHEDULE_PAGE,
  AVAILABILITY_PAGE,
  BALANCES_PAGE,
  BILLING_OVERVIEW_PAGE,
  CAREGIVER_CASH_PAGE,
  CAREGIVER_GROUP_PAGE,
  CLIENT_CATEGORY_PAGE,
  CUSTOMER_PROFILE_PAGE,
  DASHBOARD_PAGE,
  DOCTOR_PORTAL_MEASUREMENTS,
  DOCTOR_PORTAL_OVERVIEW,
  DOCTOR_PORTAL_PAGE,
  DOCTOR_PORTAL_PATIENTS,
  DOCTOR_PORTAL_PROFILE,
  DOCTOR_PORTAL_VISITS,
  DOCTOR_INSTRUCTION_QUEUE_PAGE,
  EXTERNAL_PROVIDERS_LIST,
  EXTERNAL_PROVIDERS_PAGE,
  HISTORIC_ROUTES_PAGE,
  INVENTORY_CATEGORY_PAGE,
  INVENTORY_PAGE,
  PAYMENTS_PAGE,
  PAYROLL_LIST,
  PAYROLL_PAGE,
  ROUTE_KM_REPORT_PAGE,
  SCHEDULING_PAGE,
  SERVICE_PACKAGE_PAGE,
  SERVICE_PAGE,
  SERVICE_REQUESTS_PAGE,
  SERVICE_REQUEST_ARRANGEMENT_PAGE,
  SERVICE_TYPE_PAGE,
  SHIFTS_PAGE,
  VISITS_CALENDAR_PAGE,
  VISITS_PAGE,
  VISIT_SUMMARIES_LIST,
  FORCED_ASSIGNMENTS_LIST,
} from '@app/routes/urls';
import { FaHospitalUser, FaUserDoctor, FaUsersViewfinder } from 'react-icons/fa6';
import { FiSettings } from 'react-icons/fi';
import { TbBox, TbCalendarPlus, TbClock24 } from 'react-icons/tb';

import { IoCalendarOutline, IoCalendarSharp, IoSettingsOutline, IoSettingsSharp } from 'react-icons/io5';
import { MdScheduleSend } from 'react-icons/md';
import { PiGraphDuotone } from 'react-icons/pi';
import { RxDashboard } from 'react-icons/rx';
import { RoutesStructure } from '../../../types/routing.types';

// NOTE: `label` values are i18n keys (see `menu-*` in the locale files). They are
// translated at render time in MasterLayout so the sidebar follows the language.
// import { TShowFeature } from '@app/types/features.types';
// export default (RouteConsruct: RoutesStructure, showFeature: TShowFeature) => [
export default (RouteConsruct: RoutesStructure) => {
  return [
    // Doctor portal. `show` is false for staff, so these are inert in an admin
    // menu and are the only entries left in a doctor's.
    {
      label: 'menu-doctor-overview',
      key: RouteConsruct[DOCTOR_PORTAL_PAGE].routes[DOCTOR_PORTAL_OVERVIEW].full_path,
      show: RouteConsruct[DOCTOR_PORTAL_PAGE].routes[DOCTOR_PORTAL_OVERVIEW].show,
      icon: { filled: RxDashboard, outline: RxDashboard },
    },
    {
      label: 'menu-doctor-patients',
      key: RouteConsruct[DOCTOR_PORTAL_PAGE].routes[DOCTOR_PORTAL_PATIENTS].full_path,
      show: RouteConsruct[DOCTOR_PORTAL_PAGE].routes[DOCTOR_PORTAL_PATIENTS].show,
      icon: { filled: FaUserDoctor, outline: FaUserDoctor },
    },
    {
      label: 'menu-doctor-visits',
      key: RouteConsruct[DOCTOR_PORTAL_PAGE].routes[DOCTOR_PORTAL_VISITS].full_path,
      show: RouteConsruct[DOCTOR_PORTAL_PAGE].routes[DOCTOR_PORTAL_VISITS].show,
      icon: { filled: IoCalendarSharp, outline: IoCalendarOutline },
    },
    {
      label: 'menu-doctor-measurements',
      key: RouteConsruct[DOCTOR_PORTAL_PAGE].routes[DOCTOR_PORTAL_MEASUREMENTS].full_path,
      show: RouteConsruct[DOCTOR_PORTAL_PAGE].routes[DOCTOR_PORTAL_MEASUREMENTS].show,
      icon: { filled: PiGraphDuotone, outline: PiGraphDuotone },
    },
    {
      // A group with one child today. The key is not a path, so
      // restrictMenuToDoctorPortal keeps it only because the child below is a
      // doctor path — which is also what makes it disappear if that child is
      // ever hidden, rather than leaving an empty group behind.
      label: 'menu-doctor-settings',
      key: 'doctor-settings-menu',
      show: RouteConsruct[DOCTOR_PORTAL_PAGE].routes[DOCTOR_PORTAL_PROFILE].show,
      icon: { filled: IoSettingsSharp, outline: IoSettingsOutline },
      children: [
        {
          label: 'menu-doctor-profile',
          key: RouteConsruct[DOCTOR_PORTAL_PAGE].routes[DOCTOR_PORTAL_PROFILE].full_path,
          show: RouteConsruct[DOCTOR_PORTAL_PAGE].routes[DOCTOR_PORTAL_PROFILE].show,
        },
      ],
    },
    {
      label: 'menu-dashboard',
      key: RouteConsruct[DASHBOARD_PAGE].full_path,
      show: RouteConsruct[DASHBOARD_PAGE].show,
      icon: {
        filled: RxDashboard,
        outline: RxDashboard,
      },
    },
    // TODO: remove once SERVICE_REQUESTS_PAGE is deleted; kept only so RouteConsruct's
    // `show: false` (routerHelpers.ts) has a menu entry to hide.
    {
      label: 'menu-new-request',
      key: RouteConsruct[SERVICE_REQUESTS_PAGE].full_path,
      show: RouteConsruct[SERVICE_REQUESTS_PAGE].show,
      icon: {
        filled: TbCalendarPlus,
        outline: TbCalendarPlus,
      },
    },
    // The arrangement authoring flow now IS "New Request" in the UI (see menu-new-arrangement
    // in the locale files) — it replaces the hidden item above.
    {
      label: 'menu-new-arrangement',
      key: RouteConsruct[SERVICE_REQUEST_ARRANGEMENT_PAGE].full_path,
      show: RouteConsruct[SERVICE_REQUEST_ARRANGEMENT_PAGE].show,
      // The page redirects to /initial and moves on to /compose.
      matchNested: true,
      icon: {
        filled: TbCalendarPlus,
        outline: TbCalendarPlus,
      },
    },
    {
      label: 'menu-patients',
      key: RouteConsruct.clients.routes['list'].full_path,
      show: RouteConsruct.clients.routes['list'].show,
      icon: {
        filled: FaHospitalUser,
        outline: FaHospitalUser,
      },
    },
    {
      label: 'menu-scheduling',
      key: RouteConsruct[SCHEDULING_PAGE].full_path,
      show: RouteConsruct[SCHEDULING_PAGE].show,
      icon: {
        filled: MdScheduleSend,
        outline: MdScheduleSend,
      },
    },
    {
      label: 'menu-visits',
      key: 'visits-menu',
      show: true,
      icon: {
        filled: IoCalendarSharp,
        outline: IoCalendarOutline,
      },
      children: [
        {
          label: 'menu-visit-list',
          key: RouteConsruct[VISITS_PAGE].routes['list'].full_path,
          show: RouteConsruct[VISITS_PAGE].routes['list'].show,
        },
        {
          label: 'menu-service-request-list',
          key: RouteConsruct['service-requests-management'].routes['list'].full_path,
          show: true,
        },
        {
          label: 'menu-visits-overview',
          key: RouteConsruct[VISITS_CALENDAR_PAGE].full_path,
          show: RouteConsruct[VISITS_CALENDAR_PAGE].show,
        },
        {
          label: 'menu-historic-routes',
          key: RouteConsruct[HISTORIC_ROUTES_PAGE].full_path,
          show: RouteConsruct[HISTORIC_ROUTES_PAGE].show,
        },
        {
          label: 'menu-route-km-report',
          key: RouteConsruct[ROUTE_KM_REPORT_PAGE].full_path,
          show: RouteConsruct[ROUTE_KM_REPORT_PAGE].show,
        },
        {
          label: 'menu-visit-summaries',
          key: RouteConsruct[VISITS_PAGE].routes[VISIT_SUMMARIES_LIST].full_path,
          show: RouteConsruct[VISITS_PAGE].routes[VISIT_SUMMARIES_LIST].show,
        },
        {
          label: 'menu-forced-assignments',
          key: RouteConsruct[VISITS_PAGE].routes[FORCED_ASSIGNMENTS_LIST].full_path,
          show: RouteConsruct[VISITS_PAGE].routes[FORCED_ASSIGNMENTS_LIST].show,
        },
        {
          label: 'menu-doctor-instruction-queue',
          key: RouteConsruct[DOCTOR_INSTRUCTION_QUEUE_PAGE].full_path,
          show: RouteConsruct[DOCTOR_INSTRUCTION_QUEUE_PAGE].show,
        },
      ],
    },
    {
      label: 'menu-billing',
      key: 'billing',
      show: RouteConsruct[BILLING_OVERVIEW_PAGE].show,
      icon: {
        filled: RxDashboard,
        outline: RxDashboard,
      },
      children: [
        {
          label: 'menu-billing-overview',
          key: RouteConsruct[BILLING_OVERVIEW_PAGE].full_path,
          show: true,
        },
        {
          label: 'menu-ledgers',
          key: RouteConsruct[CUSTOMER_PROFILE_PAGE].full_path,
          show: true,
        },
        {
          label: 'menu-payments',
          key: RouteConsruct[PAYMENTS_PAGE].full_path,
          show: true,
        },
        {
          label: 'menu-balances',
          key: RouteConsruct[BALANCES_PAGE].full_path,
          show: true,
        },
        {
          label: 'menu-caregiver-cash',
          key: RouteConsruct[CAREGIVER_CASH_PAGE].full_path,
          // Inherits the route's env gate (hidden unless CAREGIVER_CASH_ENABLED).
          show: RouteConsruct[CAREGIVER_CASH_PAGE].show,
        },
        {
          label: 'menu-payroll',
          key: RouteConsruct[PAYROLL_PAGE].routes[PAYROLL_LIST].full_path,
          show: RouteConsruct[PAYROLL_PAGE].routes[PAYROLL_LIST].show,
        },
      ],
    },
    {
      label: 'menu-team-patients',
      key: 'team-patients',
      show: true,
      children: [
        {
          label: 'menu-caregivers',
          key: RouteConsruct.caregivers.routes.list.full_path,
          show: RouteConsruct.caregivers.routes.list.show,
        },
        {
          label: 'menu-shifts',
          key: RouteConsruct[SHIFTS_PAGE].full_path,
          show: RouteConsruct[SHIFTS_PAGE].show,
        },
        {
          label: 'menu-doctors',
          key: RouteConsruct.doctors.routes['list'].full_path,
          show: true,
        },
        {
          label: 'menu-external-providers',
          key: RouteConsruct[EXTERNAL_PROVIDERS_PAGE].routes[EXTERNAL_PROVIDERS_LIST].full_path,
          show: RouteConsruct[EXTERNAL_PROVIDERS_PAGE].routes[EXTERNAL_PROVIDERS_LIST].show,
        },
      ],
      icon: {
        filled: FaUsersViewfinder,
        outline: FaUsersViewfinder,
      },
    },
    {
      label: 'menu-settings',
      key: 'settings',
      show: true,
      children: [
        {
          label: 'menu-users',
          key: RouteConsruct.users.routes.list.full_path,
          show: RouteConsruct.users.routes.list.show,
        },
        {
          label: 'menu-service-types',
          key: RouteConsruct[SERVICE_TYPE_PAGE].full_path,
          show: true,
        },
        {
          label: 'menu-client-categories',
          key: RouteConsruct[CLIENT_CATEGORY_PAGE].full_path,
          show: true,
        },
        {
          label: 'menu-inventory-categories',
          key: RouteConsruct[INVENTORY_CATEGORY_PAGE].full_path,
          show: RouteConsruct[INVENTORY_CATEGORY_PAGE].show,
        },
        {
          label: 'menu-caregiver-groups',
          key: RouteConsruct[CAREGIVER_GROUP_PAGE].full_path,
          show: RouteConsruct[CAREGIVER_GROUP_PAGE].show,
        },
        {
          label: 'menu-services',
          key: RouteConsruct[SERVICE_PAGE].routes['list'].full_path,
          show: true,
        },
        {
          label: 'menu-service-packages',
          key: RouteConsruct[SERVICE_PACKAGE_PAGE].routes['list'].full_path,
          show: true,
        },
        {
          label: 'menu-online-users',
          key: RouteConsruct.users.routes.online.full_path,
          show: RouteConsruct.users.routes.online.show,
        },
        {
          label: 'menu-audit-logs',
          key: RouteConsruct.users.routes['audit-logs'].full_path,
          show: RouteConsruct.users.routes['audit-logs'].show,
        },
        {
          label: 'menu-audit-trail',
          key: RouteConsruct.users.routes['audit-trail'].full_path,
          show: RouteConsruct.users.routes['audit-trail'].show,
        },
      ],
      icon: {
        filled: FiSettings,
        outline: FiSettings,
      },
    },
    {
      label: 'menu-auto-schedule',
      key: RouteConsruct[AUTO_SCHEDULE_PAGE].full_path,
      show: RouteConsruct[AUTO_SCHEDULE_PAGE].show,
      icon: {
        filled: PiGraphDuotone,
        outline: PiGraphDuotone,
      },
    },
    {
      label: 'menu-availability',
      key: RouteConsruct[AVAILABILITY_PAGE].full_path,
      show: RouteConsruct[AVAILABILITY_PAGE].show,
      icon: {
        filled: TbClock24,
        outline: TbClock24,
      },
    },
    {
      label: 'menu-inventory',
      key: RouteConsruct[INVENTORY_PAGE].full_path,
      show: RouteConsruct[INVENTORY_PAGE].show,
      icon: {
        filled: TbBox,
        outline: TbBox,
      },
    },
  ];
};
